import { useAuth } from "react-oidc-context";
import { Box, Typography, styled, alpha, Card} from '@mui/material'
import { BLACK, BLUE_LIGHT, BLUE_LIGHT_RGB_BORDER, BLUE_MAIN, GRAY_LIGHT, GREEN_LIGHT, GREEN_LOGO, WHITE } from "../../theme/colors";
import { useTranslationContext } from "../../hooks/translations/translationsProvider";
import { MarketItemProps } from "./interfaces";
import WebIco from '@mui/icons-material/Language';
import PhisicalIco from '@mui/icons-material/Home';
import UndefinedIco from '@mui/icons-material/HelpOutline';

const LinkBase = styled('a')(({ theme }) => ({
    textDecoration: 'none', 
    color:'inherit',
    '&:hover': {
        letterSpacing:'0.4px'
    },
}));

const MarketItem = (props:MarketItemProps) => {
    const {t} = useTranslationContext();

    function marketType () {
        if(props.type === 0) // Attività fisica
        {
            return (
                <Box
                    display={'flex'}
                >
                    <PhisicalIco sx={{
                        height:'20px',
                        color:'green'
                    }}/>
                    <Typography variant="body2" sx={{marginTop:'2px', color:'grey'}}>{t("Attività Fisica")}</Typography>
                </Box>
            )
        }
        else if(props.type === 1) // Attività online
        {
            return (
                <Box
                    display={'flex'}
                >
                    <WebIco sx={{
                        height:'20px',
                        color:'green'
                    }}/>
                    <Typography variant="body2" sx={{marginTop:'2px', color:'grey'}}>{t("Attività Online")}</Typography>
                </Box>
            )
        }
        else if(props.type === 2) // Attività fisica e online
        {
            return (
                <Box
                    display={'flex'}
                >
                    <WebIco sx={{
                        height:'20px',
                        color:'green'
                    }}/>
                    <PhisicalIco sx={{
                        height:'20px',
                        color:'green'
                    }}/>
                    <Typography variant="body2" sx={{marginTop:'2px', paddingLeft:'6px', color:'grey'}}>{t("Attività Online e Fisica")}</Typography>
                </Box>
            )
        }
        else
        {
            return (
                <Box
                    display={'flex'}
                >
                    <UndefinedIco sx={{
                        height:'20px',
                        color:'orange'
                    }}/>
                    <Typography variant="body2" sx={{marginTop:'2px', color:'grey'}}>{t("Attività non definita")}</Typography>
                </Box>
            )
        }
    }

    return (
        <Box sx={{
            width:'100%',
            minHeight:'120px',
            dispaly:'flex',
            flexDirection:'column'
        }}>
            <Typography sx={{
                display:'flex',
                width:'100%',
                height:'30px',
                justifyContent:'left',
                fontSize:'1.2em',
                fontWeight:600,
                color: GREEN_LOGO
            }}>
                {props.name}
            </Typography>

            <Box
                sx={{
                    height:'30px',
                    marginLeft:'-4px',
                }}
            >
                { marketType() }
            </Box>

            <Box
                sx={{
                    height: '100px', 
                    overflow: 'hidden',
                    paddingTop: 1
                }}
            >
                <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {props.address}
                </Typography>

                <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {props.cap} {props.city} {props.province} - {props.nation}
                </Typography>

                {props.phone && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {t("Tel")}: {props.phone}
                </Typography>}

                {props.mail && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    {t("E-mail")}: {props.mail}
                </Typography>}

                {props.website && <Typography sx={{
                    fontSize: '0.9rem',
                    textAlign:'left',
                    color: GREEN_LOGO, 
                    paddingTop:0,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }}>
                    <LinkBase href={props.website} target="_blank">{props.website}</LinkBase>
                </Typography>}
            </Box>

            <Box
                sx={{
                    paddingTop:1,
                    height: '80px', // Fixed height for 4 lines
                    overflow: 'hidden'
                }}
            >
                <Typography sx={{
                    fontSize: '0.8rem',
                    color: GREEN_LOGO,
                    display: '-webkit-box',
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    textAlign: 'left'
                }}>
                    {props.description}
                </Typography>
            </Box>

            {/*<Box
                sx={{
                    display:"flex",
                    width:'100%',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    paddingTop:1,
                    height: '80px', // Fixed height for 4 lines
                    overflow: 'hidden',
                    color: GREEN_LOGO
                }}
            >
                {props.tags && props.tags.length > 0 && props.tags.map((tag, index) => (
                    <Box sx={{
                        minWidth:'20px',
                        height:'20px',
                        // border:'1px solid '+ BLACK,
                        backgroundColor: GRAY_LIGHT,
                        dispaly:'flex',
                        alignItems: 'center',
                        justifyContent:'center',
                        padding:'6px 10px 0 10px',
                        margin: '4px',
                        borderRadius:'11px'
                    }} key={index}>
                        <Typography sx={{fontSize: '12px'}}>{tag}</Typography>
                    </Box>
                ))}
            </Box>*/}
        </Box>
    );
}

export default MarketItem;